<script setup>
import { defineProps, defineEmits, ref, computed, watch} from "vue";
import UtilDateTime from "@utils/UtilDateTime.js";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:alteraDado",
]);

//==================================================================//
//========================= Altera Dado ============================//
//==================================================================//

const alteraDado = (update) =>{

    emits('update:alteraDado',update);

};

//==================================================================//
//================= Desativa Nao Tem Datas =========================//
//==================================================================//

const desativaNaoTemDatas = computed(() => {

    if(props.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//=============== Desativa datas Envio Aprovação ===================//
//==================================================================//

const desativaDatasEnvioAprovacao = computed(() => {

    if(props.controlesDesativados){
        return true;
    }

    if(props.dado.naoTemEnvioAprovacao){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//================== Desativa datas Aprovação ======================//
//==================================================================//

const desativaDatasAprovacao = computed(() => {

    if(props.controlesDesativados){
        return true;
    }

    if(props.dado.naoTemAprovacao){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//================== Desativa datas Inspeção =======================//
//==================================================================//

const desativaDatasInspecao = computed(() => {

    if(props.controlesDesativados){
        return true;
    }

    if(props.dado.naoTemInspecao){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//=============== Desativa datas Entrega Fiscal ====================//
//==================================================================//

const desativaDatasEntregaFiscal = computed(() => {

    if(props.controlesDesativados){
        return true;
    }

    if(props.dado.naoTemEntregaFiscal){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//=================== Desativa datas Montagem ======================//
//==================================================================//

const desativaDatasMontagem = computed(() => {

    if(props.controlesDesativados){
        return true;
    }

    if(props.dado.naoTemMontagem){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//==================== Desativa datas Startup ======================//
//==================================================================//

const desativaDatasStartup = computed(() => {

    if(props.controlesDesativados){
        return true;
    }

    if(props.dado.naoTemStartup){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//========= Desativa Datas Entrega Final Contratual ================//
//==================================================================//

const desativaDatasEntregaFinalContratual = computed(() => {

    if(props.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//============ Ao Selecionar Não Tem Envio Aprovação ===============//
//==================================================================//

const aoSelecionarNaoTemEnvioAprovacao = (naoTemEnvioAprovacao = false) => {

    alteraDado({
        naoTemEnvioAprovacao: naoTemEnvioAprovacao || false,
        dataEnvioAprovacaoContratual: "",
        dataEnvioAprovacaoContratualFormatada: "",
        dataEnvioAprovacaoEfetiva: "",
        dataEnvioAprovacaoEfetivaFormatada: "",
    });

};

//==================================================================//
//=============== Ao Selecionar Não Tem Aprovação ==================//
//==================================================================//

const aoSelecionarNaoTemAprovacao = (naoTemAprovacao = false) => {

    alteraDado({
        naoTemAprovacao: naoTemAprovacao || false,
        dataAprovacaoPrevista: "",
        dataAprovacaoPrevistaFormatada: "",
        dataAprovacaoEfetiva: "",
        dataAprovacaoEfetivaFormatada: "",
    });

};

//==================================================================//
//=============== Ao Selecionar Não Tem Inspecao ===================//
//==================================================================//

const aoSelecionarNaoTemInspecao = (naoTemInspecao = false) => {

    alteraDado({
        naoTemInspecao: naoTemInspecao || false,
        dataInspecaoPrevista: "",
        dataInspecaoPrevistaFormatada: "",
        dataInspecaoEfetiva: "",
        dataInspecaoEfetivaFormatada: "",
    });

};

//==================================================================//
//============ Ao Selecionar Não Tem Entrega Fiscal ================//
//==================================================================//

const aoSelecionarNaoTemEntregaFiscal = (naoTemEntregaFiscal = false) => {

    alteraDado({
        naoTemEntregaFiscal: naoTemEntregaFiscal || false,
        dataEntregaFiscalPrevista: "",
        dataEntregaFiscalPrevistaFormatada: "",
        dataEntregaFiscalEfetiva: "",
        dataEntregaFiscalEfetivaFormatada: "",
    });

};

//==================================================================//
//=============== Ao Selecionar Não Tem Montagem ===================//
//==================================================================//

const aoSelecionarNaoTemMontagem = (naoTemMontagem = false) => {

    alteraDado({
        naoTemMontagem: naoTemMontagem || false,
        dataMontagemContratual: "",
        dataMontagemContratualFormatada: "",
        dataMontagemEfetiva: "",
        dataMontagemEfetivaFormatada: "",
    });

};

//==================================================================//
//=============== Ao Selecionar Não Tem Startup ====================//
//==================================================================//

const aoSelecionarNaoTemStartup = (naoTemStartup = false) => {

    alteraDado({
        naoTemStartup: naoTemStartup || false,
        dataStartupPrevista: "",
        dataStartupPrevistaFormatada: "",
        dataStartupEfetiva: "",
        dataStartupEfetivaFormatada: "",
    });

};

//==================================================================//
//========= Ao Selecionar Data Envio Aprovacao Contratual ==========//
//==================================================================//

const aoSelecionarDataEnvioAprovacaoContratual = (dataEnvioAprovacaoContratual) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataEnvioAprovacaoContratual})){

        alteraDado({
            dataEnvioAprovacaoContratual: "",
            dataEnvioAprovacaoContratualFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataEnvioAprovacaoContratual: UtilDateTime.toFormatUTC({dateTime:dataEnvioAprovacaoContratual}),
        dataEnvioAprovacaoContratualFormatada: UtilDateTime.toFormatBrazil({dateTime:dataEnvioAprovacaoContratual}),
    });

};

//==================================================================//
//========== Ao Selecionar Data Envio Aprovacao Efetiva ============//
//==================================================================//

const aoSelecionarDataEnvioAprovacaoEfetiva = (dataEnvioAprovacaoEfetiva) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataEnvioAprovacaoEfetiva})){

        alteraDado({
            dataEnvioAprovacaoEfetiva: "",
            dataEnvioAprovacaoEfetivaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataEnvioAprovacaoEfetiva: UtilDateTime.toFormatUTC({dateTime:dataEnvioAprovacaoEfetiva}),
        dataEnvioAprovacaoEfetivaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataEnvioAprovacaoEfetiva}),
    });

};

//==================================================================//
//============= Ao Selecionar Data Aprovacao Previsto ==============//
//==================================================================//

const aoSelecionarDataAprovacaoPrevista = (dataAprovacaoPrevista) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataAprovacaoPrevista})){

        alteraDado({
            dataAprovacaoPrevista: "",
            dataAprovacaoPrevistaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataAprovacaoPrevista: UtilDateTime.toFormatUTC({dateTime:dataAprovacaoPrevista}),
        dataAprovacaoPrevistaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataAprovacaoPrevista}),
    });

};

//==================================================================//
//============= Ao Selecionar Data Aprovacao Efetiva ===============//
//==================================================================//

const aoSelecionarDataAprovacaoEfetiva = (dataAprovacaoEfetiva) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataAprovacaoEfetiva})){

        alteraDado({
            dataAprovacaoEfetiva: "",
            dataAprovacaoEfetivaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataAprovacaoEfetiva: UtilDateTime.toFormatUTC({dateTime:dataAprovacaoEfetiva}),
        dataAprovacaoEfetivaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataAprovacaoEfetiva}),
    });

};

//==================================================================//
//============= Ao Selecionar Data Inspeção Prevista ===============//
//==================================================================//

const aoSelecionarDataInspecaoPrevista = (dataInspecaoPrevista) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataInspecaoPrevista})){

        alteraDado({
            dataInspecaoPrevista: "",
            dataInspecaoPrevistaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataInspecaoPrevista: UtilDateTime.toFormatUTC({dateTime:dataInspecaoPrevista}),
        dataInspecaoPrevistaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataInspecaoPrevista}),
    });

};

//==================================================================//
//============== Ao Selecionar Data Inspeção Efetiva ===============//
//==================================================================//

const aoSelecionarDataInspecaoEfetiva = (dataInspecaoEfetiva) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataInspecaoEfetiva})){

        alteraDado({
            dataInspecaoEfetiva: "",
            dataInspecaoEfetivaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataInspecaoEfetiva: UtilDateTime.toFormatUTC({dateTime:dataInspecaoEfetiva}),
        dataInspecaoEfetivaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataInspecaoEfetiva}),
    });

};

//==================================================================//
//========== Ao Selecionar Data Entrega Fiscal Prevista ============//
//==================================================================//

const aoSelecionarDataEntregaFiscalPrevista = (dataEntregaFiscalPrevista) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataEntregaFiscalPrevista})){

        alteraDado({
            dataEntregaFiscalPrevista: "",
            dataEntregaFiscalPrevistaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataEntregaFiscalPrevista: UtilDateTime.toFormatUTC({dateTime:dataEntregaFiscalPrevista}),
        dataEntregaFiscalPrevistaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataEntregaFiscalPrevista}),
    });

};

//==================================================================//
//=========== Ao Selecionar Data Entrega Fiscal Prevista ===========//
//==================================================================//

const aoSelecionarDataEntregaFiscalEfetiva = (dataEntregaFiscalEfetiva) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataEntregaFiscalEfetiva})){

        alteraDado({
            dataEntregaFiscalEfetiva: "",
            dataEntregaFiscalEfetivaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataEntregaFiscalEfetiva: UtilDateTime.toFormatUTC({dateTime:dataEntregaFiscalEfetiva}),
        dataEntregaFiscalEfetivaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataEntregaFiscalEfetiva}),
    });

};

//==================================================================//
//============ Ao Selecionar Data Montagem Contratual ==============//
//==================================================================//

const aoSelecionarDataMontagemContratual = (dataMontagemContratual) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataMontagemContratual})){

        alteraDado({
            dataMontagemContratual: "",
            dataMontagemContratualFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataMontagemContratual: UtilDateTime.toFormatUTC({dateTime:dataMontagemContratual}),
        dataMontagemContratualFormatada: UtilDateTime.toFormatBrazil({dateTime:dataMontagemContratual}),
    });

};

//==================================================================//
//============== Ao Selecionar Data Montagem Efetiva ===============//
//==================================================================//

const aoSelecionarDataMontagemEfetiva = (dataMontagemEfetiva) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataMontagemEfetiva})){

        alteraDado({
            dataMontagemEfetiva: "",
            dataMontagemEfetivaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataMontagemEfetiva: UtilDateTime.toFormatUTC({dateTime:dataMontagemEfetiva}),
        dataMontagemEfetivaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataMontagemEfetiva}),
    });

};

//==================================================================//
//============== Ao Selecionar Data Startup Prevista ===============//
//==================================================================//

const aoSelecionarDataStartupPrevista = (dataStartupPrevista) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataStartupPrevista})){

        alteraDado({
            dataStartupPrevista: "",
            dataStartupPrevistaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataStartupPrevista: UtilDateTime.toFormatUTC({dateTime:dataStartupPrevista}),
        dataStartupPrevistaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataStartupPrevista}),
    });

};

//==================================================================//
//============== Ao Selecionar Data Startup Efetiva ================//
//==================================================================//

const aoSelecionarDataStartupEfetiva = (dataStartupEfetiva) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataStartupEfetiva})){

        alteraDado({
            dataStartupEfetiva: "",
            dataStartupEfetivaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataStartupEfetiva: UtilDateTime.toFormatUTC({dateTime:dataStartupEfetiva}),
        dataStartupEfetivaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataStartupEfetiva}),
    });

};

//==================================================================//
//============== Ao Selecionar Data Final Contratual ===============//
//==================================================================//

const aoSelecionarDataFinalContratual = (dataFinalContratual) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataFinalContratual})){

        alteraDado({
            dataFinalContratual: "",
            dataFinalContratualFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataFinalContratual: UtilDateTime.toFormatUTC({dateTime:dataFinalContratual}),
        dataFinalContratualFormatada: UtilDateTime.toFormatBrazil({dateTime:dataFinalContratual}),
    });

};

//==================================================================//
//=============== Ao Selecionar Data Final Efetiva =================//
//==================================================================//

const aoSelecionarDataFinalEfetiva = (dataFinalEfetiva) => {

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataFinalEfetiva})){

        alteraDado({
            dataFinalEfetiva: "",
            dataFinalEfetivaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraDado({
        dataFinalEfetiva: UtilDateTime.toFormatUTC({dateTime:dataFinalEfetiva}),
        dataFinalEfetivaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataFinalEfetiva}),
    });

};

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">Datas</h3>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Envio para Aprovação</h3>

                    <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemEnvioAprovacao"
                        :value="props?.dado?.naoTemEnvioAprovacao"
                        :disabled="desativaNaoTemDatas"
                        hide-details
                        @change="aoSelecionarNaoTemEnvioAprovacao"
                    ></v-checkbox>

                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Contratual"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataEnvioAprovacaoContratual})"
                            :disabled="desativaDatasEnvioAprovacao"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataEnvioAprovacaoContratual"
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataEnvioAprovacaoEfetiva})"
                            :disabled="desativaDatasEnvioAprovacao"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataEnvioAprovacaoEfetiva"
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                     <h3>Aprovação</h3>

                     <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemAprovacao"
                        :value="props?.dado?.naoTemAprovacao"
                        :disabled="desativaNaoTemDatas"
                        hide-details
                        @change="aoSelecionarNaoTemAprovacao"
                    ></v-checkbox>


                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Prevista"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataAprovacaoPrevista})"
                            :disabled="desativaDatasAprovacao"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataAprovacaoPrevista"
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataAprovacaoEfetiva})"
                            :disabled="desativaDatasAprovacao"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataAprovacaoEfetiva"
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Inspeção</h3>

                    <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemInspecao"
                        :value="props?.dado?.naoTemInspecao"
                        :disabled="desativaNaoTemDatas"
                        hide-details
                        @change="aoSelecionarNaoTemInspecao"
                    ></v-checkbox>

                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Prevista"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataInspecaoPrevista})"
                            :disabled="desativaDatasInspecao"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataInspecaoPrevista"
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataInspecaoEfetiva})"
                            :disabled="desativaDatasInspecao"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataInspecaoEfetiva"
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Entrega Fiscal</h3>

                    <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemEntregaFiscal"
                        :value="props?.dado?.naoTemEntregaFiscal"
                        :disabled="desativaNaoTemDatas"
                        hide-details
                        @change="aoSelecionarNaoTemEntregaFiscal"
                    ></v-checkbox>


                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Prevista"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataEntregaFiscalPrevista})"
                            :disabled="desativaDatasEntregaFiscal"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataEntregaFiscalPrevista"
                        ></v-text-field>

                    </div>

                    <div class="c-campo">
                        
                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataEntregaFiscalEfetiva})"
                            :disabled="desativaDatasEntregaFiscal"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataEntregaFiscalEfetiva"
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Montagem</h3>

                    <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemMontagem"
                        :value="props?.dado?.naoTemMontagem"
                        :disabled="desativaNaoTemDatas"
                        hide-details
                        @change="aoSelecionarNaoTemMontagem"
                    ></v-checkbox>

                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Contratual"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataMontagemContratual})"
                            :disabled="desativaDatasMontagem"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataMontagemContratual"
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataMontagemEfetiva})"
                            :disabled="desativaDatasMontagem"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataMontagemEfetiva"
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Start-UP</h3>

                    <v-checkbox class="c-titulo__checkbox"
                        label="Não tem"
                        color="primary"
                        :input-value="props?.dado?.naoTemStartup"
                        :value="props?.dado?.naoTemStartup"
                        :disabled="desativaNaoTemDatas"
                        hide-details
                        @change="aoSelecionarNaoTemStartup"
                    ></v-checkbox>

                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Prevista"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataStartupPrevista})"
                            :disabled="desativaDatasStartup"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataStartupPrevista"
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataStartupEfetiva})"
                            :disabled="desativaDatasStartup"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataStartupEfetiva"
                        ></v-text-field>

                    </div>

                </div>

            </div>

            <div class="c-grupo">

                <div class="c-grupo__titulo">

                    <h3>Entrega Final Contratual</h3>

                </div>

                <div class="c-grupo__conteudo">

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Contratual"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataFinalContratual})"
                            :disabled="desativaDatasEntregaFinalContratual"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataFinalContratual"
                        ></v-text-field>

                    </div>

                    <div class="c-campo">

                        <v-text-field class="c-campo__input"
                            label="Efetiva"
                            :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataFinalEfetiva})"
                            :disabled="desativaDatasEntregaFinalContratual"
                            type="date"
                            prepend-icon="mdi-calendar" 
                            outlined
                            return-object
                            @input="aoSelecionarDataFinalEfetiva"
                        ></v-text-field>

                    </div>

                </div>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-titulo {
    grid-area: titulo;
}

.c-cartao__conteudo{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 20px;
}

.c-grupo{
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
    padding: 15px;
}

.c-grupo__titulo{
    display: grid;
    grid-template-rows: max-content 1fr;
    grid-gap: 5px;
    padding: 0px 0px 15px 0px;
}

.c-titulo__checkbox{
    padding: 0px;
    margin: 0px;
    max-width: fit-content;
}

</style>